import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useRef, useEffect } from 'react';
import TikTokAdsSSORegister from '@byted/common-register-i18n-sdk';

// doc https://web-**************/package/@byted/common-register-i18n-sdk?from=from_parent_docs
export interface AdsRegisterProps {
  ssoConfig: {
    appId: number; // 产品线申请的 appId
    service: string; // 注册成功后的回调地址
    panelType?: 'register' | 'bind'; // 面板类型：支持注册、绑定（默认类型为accountTypes第一个值），默认 'register'
    accountTypes?: ('email' | 'mobile')[]; // 账户类型，支持手机/邮箱，优先展示第一个，默认 ['mobile', 'email']
    signIn?: string | ((...args: any[]) => any); // 登陆按钮点击后的跳转外链（新开页打开） or 点击回调函数
    lang?: string; // 多语言类型，支持的语言种类见附录，默认 'en'
    className?: string;
    isAgreement?: boolean; // 默认勾选协议，默认 false
    external?: string; // 风控自定义字段 JSON字符串
    defaultArea?: string; // 例如：+86，accountTypes包括mobile才有效
    defaultCountry?: string; // 例如：CN，accountTypes包括mobile才有效
    isSimplifyMode?: boolean; // 是否启用简化版的注册，启用后，密码输入框升级为1秒后自动隐藏的输入方式，去掉了确认密码输入框，条款选择框，以及发送验证码的“没有收到验证码”的帮助放在输入框右侧；默认 false
    defaultSelectAccountTypeByDevice?: boolean; // 根据设备选择account输入框，pc => email输入框, mobile => phone 输入框, 优先级高于 defaultSelectAccountType；默认 false
    defaultSelectAccountType?: 'email' | 'mobile'; // 默认选择的account输入框
    registerSuccess?: (...args: any[]) => any; // 注册成功的回调函数；如果不传，登录成功后会redirect 到 sso 登录接口返回的 redirect_url 上
    registerFail?: (...args: any[]) => any; // 注册失败的回调函数
    acTypeChange?: (...args: any[]) => any; // 切换手机号/邮箱输入框的回调
    phoneAreaChange?: (...args: any[]) => any; // 手机号输入框选择的区号改变时的回调
    // spy callbacks
    codeCb?: () => void; // 发送验证码验证成功后
    agreementCb?: (isCheck: boolean) => void; // 点击协议, 返回参数是否勾选
    clickCodeHelpCb?: () => void; // 点击或hover以查看验证码帮助
  };
  id?: string;
  style?: React.CSSProperties;
  className?: string;
}

export interface AdsRegisterRef {
  getInstance: () => any;
}

const RegisterContainer: ForwardRefRenderFunction<AdsRegisterRef, AdsRegisterProps> = (props, ref) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const ssoRef = useRef<any>(null);
  const { id = 'sso_register', style = {}, className = '' } = props;
  useImperativeHandle(ref, () => ({
    getInstance: () => ssoRef.current
  }));
  useEffect(() => {
    const instance = new TikTokAdsSSORegister({
      ...props.ssoConfig,
      id
    });
    ssoRef.current = instance;
    instance.render();
  }, []);
  return <div ref={containerRef} id={id} style={style} className={className} />;
};
export const AdsRegister = forwardRef(RegisterContainer);
export default AdsRegister;
